import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';

function ScrollProgress() {
    const [progress, setProgress] = useState(0);
    const { theme } = useContext(ThemeContext);

    useEffect(() => {
        const onScroll = () => {
            const scrolled = window.scrollY;
            const total = document.documentElement.scrollHeight - window.innerHeight;
            setProgress(total > 0 ? (scrolled / total) * 100 : 0);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: `${progress}%`,
            height: '3px',
            background: `linear-gradient(90deg, ${theme.primary}, ${theme.tertiary})`,
            zIndex: 9999,
            transition: 'width 0.08s linear',
            boxShadow: `0 0 10px ${theme.primary}80`,
            borderRadius: '0 2px 2px 0',
            pointerEvents: 'none',
        }} />
    );
}

export default ScrollProgress;
